export default __webpack_public_path__ + "media/images/icons_fc/doc_pinned-ef65fd3795c6173c155009a34d7b8faa.png";